import { LocationModel } from "@insite/client-framework/Common/Hooks/useLocationFilterSearch";
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import * as React from "react";

type LocationContentLinkProps = LinkPresentationProps & {
    location: LocationModel;
    onOpenLocationContent: (location: LocationModel) => void;
};

const LocationContentLink: React.FC<LocationContentLinkProps> = ({
    location,
    onOpenLocationContent,
    ...otherProps
}) => {
    // <xng-change>: EIS-2148
    if (!(location as any)?.properties?.hours) {
        return null;
    }
    // </xng-change>
    const handleContentClicked = (event: React.MouseEvent<HTMLAnchorElement>) => {
        event.preventDefault();
        onOpenLocationContent(location);
    };
    return (
        <Link onClick={handleContentClicked} {...otherProps}>
            {translate("Hours")}
        </Link>
    );
};

export default LocationContentLink;
